import { useMemo } from 'react'
import { buildSideBySideTextDiff } from '../../utils/textDiff'
import './SideBySideTextDiff.css'

const getDiffMarker = (tone) => {
  if (tone === 'removed') {
    return '-'
  }

  if (tone === 'added') {
    return '+'
  }

  if (tone === 'unchanged') {
    return ' '
  }

  return ''
}

const SideBySideTextDiff = ({
  baseLabel,
  baseText,
  compareLabel,
  compareText,
  emptyMessage,
  panelId,
  regionLabel = 'Text comparison',
}) => {
  const diffDetails = useMemo(
    () => buildSideBySideTextDiff(baseText, compareText),
    [baseText, compareText],
  )
  const resolvedEmptyMessage =
    emptyMessage ||
    `No text differences between ${baseLabel} and ${compareLabel}.`

  return (
    <div className="side-by-side-text-diff" id={panelId}>
      <div className="side-by-side-text-diff__legend">
        <div className="side-by-side-text-diff__party">
          <strong>{baseLabel}</strong>
        </div>
        <div className="side-by-side-text-diff__party">
          <strong>{compareLabel}</strong>
        </div>
      </div>

      {diffDetails.hasChanges ? (
        <div
          aria-label={regionLabel}
          className="side-by-side-text-diff__content"
          role="region"
        >
          {diffDetails.rows.map((row) => (
            <div className="side-by-side-text-diff__row" key={row.id}>
              <div
                className={`side-by-side-text-diff__cell side-by-side-text-diff__cell--${row.leftTone}`}
              >
                <span
                  aria-hidden="true"
                  className="side-by-side-text-diff__marker"
                >
                  {getDiffMarker(row.leftTone)}
                </span>
                <span className="side-by-side-text-diff__text">
                  {row.leftText.length > 0 ? row.leftText : ' '}
                </span>
              </div>
              <div
                className={`side-by-side-text-diff__cell side-by-side-text-diff__cell--${row.rightTone}`}
              >
                <span
                  aria-hidden="true"
                  className="side-by-side-text-diff__marker"
                >
                  {getDiffMarker(row.rightTone)}
                </span>
                <span className="side-by-side-text-diff__text">
                  {row.rightText.length > 0 ? row.rightText : ' '}
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="side-by-side-text-diff__empty">{resolvedEmptyMessage}</p>
      )}
    </div>
  )
}

export default SideBySideTextDiff
